import React, { useState } from 'react';
import { Navbar } from '../App';
import contentPT from '../data/content.pt.json';
import contentEN from '../data/content.en.json';

export default function Contact() {
  const lang = 'en';
  const content = contentEN;
  const t = (pt, en) => en;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      phone: formData.get('phone'),
      email: formData.get('email'),
      message: formData.get('message'),
      source: 'Magic Fish Pictures - Contact Form'
    };

    try {
      // Get webhook URL from runtime config or fallback to build-time env
      let webhookUrl = window._env_?.REACT_APP_SV_WEBHOOK || process.env.REACT_APP_SV_WEBHOOK;
      
      if (!webhookUrl) {
        throw new Error('Webhook URL not configured');
      }

      // Force HTTPS if site is HTTPS to avoid mixed content warning
      if (window.location.protocol === 'https:' && webhookUrl.startsWith('http://')) {
        console.warn('Converting HTTP webhook to HTTPS to avoid mixed content');
        webhookUrl = webhookUrl.replace('http://', 'https://');
      }

      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setSubmitStatus('success');
      e.target.reset();
    } catch (error) {
      console.error('Error sending form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Use dark + black text to match blank/light page */}
      <Navbar brand={content.brand} dark navColor="black" />
      <main className="page contact-page">
        <div className="contact-container">
          <div className="contact-grid">
            {/* Left column */}
            <div className="contact-left">
              <img src="/logo.png" alt={content.brand} className="contact-logo" />
              <h1 className="contact-title">{t('CONTACTO', 'CONTACT')}</h1>
              <div className="contact-info">
                <div>
                  <span className="ci-label">{t('E-mail', 'Email')}</span>
                  <a href="mailto:hello@magicfishpictures.com" className="ci-link">hello@magicfishpictures.com</a>
                </div>
                <div>
                  <span className="ci-label">{t('Telefone', 'Phone')}</span>
                  <a 
                    href="https://wa.me/351934801158" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="ci-link whatsapp-link"
                    aria-label="Contact via WhatsApp"
                  >
                    WhatsApp
                  </a>
                </div>
                <div className="ci-socials">
                  <span className="ci-label">{t('Redes', 'Social')}</span>
                  <div className="ci-links">
                    <a href="https://www.instagram.com/magicfishpictures/" target="_blank" rel="noopener noreferrer" className="ci-link">Instagram</a>
                    {/* <a href="#" className="ci-link">Vimeo</a> */}
                    {/* <a href="#" className="ci-link">YouTube</a> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Vertical divider */}
            <div className="contact-divider" aria-hidden="true" />

            {/* Right column */}
            <div className="contact-right">
              <form
                className="contact-form"
                onSubmit={handleSubmit}
              >
                <div className="form-row">
                  <label htmlFor="name">{t('Nome', 'Name')}</label>
                  <input id="name" name="name" type="text" placeholder={t('Seu nome', 'Your name')} required />
                </div>
                <div className="form-row">
                  <label htmlFor="phone">{t('Telefone', 'Phone')}</label>
                  <input id="phone" name="phone" type="tel" placeholder={t('(xx) xxxxx-xxxx', '(area) number')} />
                </div>
                <div className="form-row">
                  <label htmlFor="email">Email</label>
                  <input id="email" name="email" type="email" placeholder="you@example.com" required />
                </div>
                <div className="form-row">
                  <label htmlFor="message">{t('Mensagem', 'Message')}</label>
                  <textarea id="message" name="message" rows="6" placeholder={t('Escreva sua mensagem...', 'Write your message...')} />
                </div>
                <div className="form-actions">
                  <button type="submit" className="btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? t('ENVIANDO...', 'SENDING...') : t('ENVIAR', 'SEND')}
                  </button>
                </div>
                {submitStatus === 'success' && (
                  <p className="form-message success">{t('Mensagem enviada com sucesso!', 'Message sent successfully!')}</p>
                )}
                {submitStatus === 'error' && (
                  <p className="form-message error">{t('Erro ao enviar mensagem. Tente novamente.', 'Error sending message. Please try again.')}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
